module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mdl-grid adv-content",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "page-user-info"
    }
  }, [_c('div', {
    staticClass: "adv-user-container mdl-shadow--2dp mdl-cell mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "adv-user-avatar"
  }), _vm._v(" "), _c('div', {
    staticClass: "adv-name-follow-container mdl-cell mdl-cell--5-col"
  }, [_c('div', {
    staticClass: "adv-user-username"
  }), _vm._v(" "), _c('div', {
    staticClass: "adv-signed-in-only"
  }, [_c('label', {
    staticClass: "adv-follow mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": "follow"
    }
  }, [_c('input', {
    staticClass: "mdl-switch__input",
    attrs: {
      "type": "checkbox",
      "id": "follow",
      "value": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-switch__label"
  }, [_vm._v("Follow")])])]), _vm._v(" "), _c('div', {
    staticClass: "adv-user-detail-container"
  }, [_c('div', {
    staticClass: "adv-user-detail"
  }, [_c('span', {
    staticClass: "adv-user-nbposts"
  }, [_vm._v("0")]), _vm._v(" adventures played")]), _vm._v(" "), _c('div', {
    staticClass: "adv-user-detail"
  }, [_c('span', {
    staticClass: "adv-user-nbfollowers"
  }, [_vm._v("0")]), _vm._v(" adventures created")])])])]), _vm._v(" "), _c('div', {
    staticClass: "adv-user-following mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col"
  }, [_c('button', {
    staticClass: "adv-close-following  mdl-button mdl-js-button mdl-button--raised mdl-button--fab"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_less")])])]), _vm._v(" "), _c('div', {
    staticClass: "adv-image-container mdl-cell mdl-cell--12-col mdl-grid"
  }, [_c('div', {
    staticClass: "adv-no-posts mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop mdl-grid mdl-grid--no-spacing"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp mdl-cell\n              mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--8-col-desktop"
  }, [_vm._v("\n        No comments yet.\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "adv-next-page-button"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--fab"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c8dd9bd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionUserProfile.vue
// module id = 307
// module chunks = 0